import { render } from "./MerchantManageCreatePage.vue?vue&type=template&id=079bb2b6&lang=true"
import script from "./MerchantManageCreatePage.vue?vue&type=script&lang=js"
export * from "./MerchantManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__